<a routerLink="/admin/dashboard" class="d-inline-block mb-2">
  <i class="fa-solid fa-arrow-left"></i> Back
</a>
<div class="card col-lg-4 col-12">
  <div class="card-body ">

    <h3>Edit User</h3>
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">

      <div class="mb-3">
        <label for="userName" class="form-label">Username</label>
        <input type="text" id="userName" formControlName="userName" class="form-control">
      </div>

      <div class="mb-3">
        <label for="firstName" class="form-label">First Name</label>
        <input type="text" id="firstName" formControlName="firstName" class="form-control"
               [class.is-invalid]="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched">
        <div *ngIf="userForm.get('firstName')?.invalid && userForm.get('firstName')?.touched" class="invalid-feedback">
          First name is required.
        </div>
      </div>

      <div class="mb-3">
        <label for="lastName" class="form-label">Last Name</label>
        <input type="text" id="lastName" formControlName="lastName" class="form-control"
               [class.is-invalid]="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched">
        <div *ngIf="userForm.get('lastName')?.invalid && userForm.get('lastName')?.touched" class="invalid-feedback">
          Last name is required.
        </div>
      </div>

      <div class="mb-3">
        <label for="subscriptionLevel" class="form-label">Subscription Level</label>
        <select id="subscriptionLevel" formControlName="subscriptionLevel" class="form-select">
          <option value="Trial">Trial</option>
          <option value="Lite">Lite</option>
          <option value="Advanced">Advanced</option>
        </select>
      </div>

      <div class="mb-3">
        <label for="customerId" class="form-label">Customer Id</label>
        <input type="text" id="customerId" formControlName="customerId" class="form-control">
      </div>

      <h5 class="mt-2">AI Enginner Subscription</h5>

      @if(user?.hasAIEngineerSubscription){
      <div class="mb-3">
        <label for="aieExpirationDate" class="form-label">Expiration Date</label>
        <input type="date" id="aieExpirationDate" formControlName="aieExpirationDate" class="form-control"
               [class.is-invalid]="userForm.errors?.['aieExpirationRequired'] && userForm.get('aieExpirationDate')?.touched" />
        <div *ngIf="userForm.errors?.['aieExpirationRequired']" class="text-danger">
          Expiration date is required.
        </div>
      </div>

      <div class="mb-3">
        <label for="aieCancelledDate" class="form-label">Cancelled Date</label>
        <input type="text" id="aieCancelledDate" formControlName="aieCancelledDate" class="form-control" />
      </div>

      <div class="mb-3">
        <label for="aieMonthlyRequests" class="form-label">Monthly Requests</label>
        <input type="number" id="aieMonthlyRequests" formControlName="aieMonthlyRequests" class="form-control" />
      </div>

      <div class="mb-3">
        <label for="aieLastRequestedDate" class="form-label">Last Request Date</label>
        <input type="datetime" id="aieLastRequestedDate" formControlName="aieLastRequestedDate" class="form-control" />
      </div>

      }
      @else{
      <button class="btn btn-outline-primary btn-sm mb-3" (click)="addAIEngineerSubscription()" type="button">Add AI Engineer</button>

      }


      <div class="form-check mb-3">
        <input type="checkbox" id="isEnabled" formControlName="isEnabled" class="form-check-input">
        <label for="isEnabled" class="form-check-label">Is Enabled</label>
      </div>

      <div class="mb-3">
        Created: <strong>{{user?.created | date:"yyyy-MM-dd hh:mm:ss a"}}</strong>
      </div>

      <div class="d-flex justify-content-end flex-wrap">
        <button type="button" class="btn btn-outline-primary m-1" (click)="cancel()">
          Cancel
        </button>

        <button type="submit" class="btn btn-primary m-1" [disabled]="userForm.invalid">
          Save Changes
        </button>
      </div>

      <div class="alert alert-success mt-3" *ngIf="savedSuccess">
        User account updated!
      </div>
      <div class="alert alert-danger mt-3 text-pre-line" *ngIf="savedFailed">
        {{savedErrorMessage}}
      </div>
    </form>
  </div>
</div>
